import React from "react";
import { Box } from "@mui/material";
import agent from "../../assets/leads-table/agent.svg";
import filter from "../../assets/leads-table/filter.svg";
import search from "../../assets/leads-table/search.svg";
import importIcon from "../../assets/leads-table/import.svg";
import addLead from "../../assets/leads-table/add-lead.svg";
import add from "../../assets/figma-icons/add.svg";
import share from "../../assets/figma-icons/share.svg";
import sequence from "../../assets/figma-icons/sequence.svg";
import document from "../../assets/figma-icons/document.svg";
import assignTeam from "../../assets/figma-icons/assign-team.svg";
import match from "../../assets/figma-icons/match.svg";
import convert from "../../assets/figma-icons/convert.svg";
import schedule from "../../assets/figma-icons/schedule.svg";
import contact from "../../assets/figma-icons/contact.svg";
import email from "../../assets/figma-icons/email.svg";
import resume from "../../assets/figma-icons/resume.svg";
import client from "../../assets/figma-icons/client.svg";
import job from "../../assets/figma-icons/job.svg";
import headerSearch from "../../assets/figma-icons/header-search.svg";
import notification from "../../assets/figma-icons/notification.svg";
import tableEmail from "../../assets/figma-icons/table-email.svg";
import tableDocument from "../../assets/figma-icons/table-document.svg";

import assetTrash from "../../assets/figma-icons/trash.svg";
import assetSms from "../../assets/figma-icons/sms.svg";
import assetCall from "../../assets/figma-icons/call.svg";
import assetGlobal from "../../assets/figma-icons/global.svg";
import assetEye from "../../assets/figma-icons/eye.svg";
import assetNoteText from "../../assets/figma-icons/note-text.svg";
import assetEdit from "../../assets/figma-icons/edit.svg";
import assetLink from "../../assets/figma-icons/link.svg";
import assetExport from "../../assets/figma-icons/export.svg";
import assetGrid from "../../assets/figma-icons/grid.svg";
import assetList from "../../assets/figma-icons/list.svg";
import assetMore from "../../assets/figma-icons/more.svg";
import assetPopupOwner from "../../assets/figma-icons/popup-owner.svg";
import assetPopupShare from "../../assets/figma-icons/popup-share.svg";

const assets = { "trash": assetTrash, "sms": assetSms, "call": assetCall, "global": assetGlobal, "eye": assetEye, "note-text": assetNoteText, "edit": assetEdit, "link": assetLink, "export": assetExport, "grid": assetGrid, "list": assetList, "more": assetMore, "popup-owner": assetPopupOwner, "popup-share": assetPopupShare, agent, filter, search, import: importIcon, addLead, add, share,
  sequence, document, assignTeam, match, convert, schedule, contact, email,
  resume, client, job, headerSearch, notification, tableEmail, tableDocument };

// Masks preserve the exported geometry while inheriting button hover/disabled color.
export default function FigmaIcon({ name, size, color = "currentColor", sx, ...props }) {
  const dimension = size ?? ({ search: 22, headerSearch: 24, notification: 24,
    "popup-owner": 32, "popup-share": 32, sms: 24, call: 24, global: 24, grid: 24, list: 24, tableEmail: 22, tableDocument: 22 }[name] || 20);
  return <Box component="span" aria-hidden="true" data-figma-icon={name} {...props}
    sx={[{ display: "inline-block", flexShrink: 0, width: dimension, height: dimension,
      color, backgroundColor: "currentColor", maskImage: `url("${assets[name]}")`,
      WebkitMaskImage: `url("${assets[name]}")`, maskSize: "contain",
      WebkitMaskSize: "contain", maskRepeat: "no-repeat", WebkitMaskRepeat: "no-repeat",
      maskPosition: "center", WebkitMaskPosition: "center", verticalAlign: "middle" }, sx]} />;
}

export function getFigmaActionIcon(label) {
  const value = String(label || "").trim().toLowerCase();
  const name = {
    call: "call", add: "add", share: "share", "share job": "share", "share candidate": "share",
    "assign team": "assignTeam", "assign client": "client", "assign job": "job",
    "convert to job": "convert", "contact lead": "contact", schedule: "schedule",
    email: "email", resume: "resume", "pitch package": "document", proposal: "document",
    "create sequence": "sequence", "add to sequence": "sequence",
    "launch recruiting sequence": "sequence", "match candidates": "match",
    "match to job": "match", "filter by": "filter", "filter by...": "filter",
    "import csv": "import", "ai agent": "agent", "add agent": "agent",
    "launch agent": "agent", "add new lead": "addLead",
  }[value];
  return name ? <FigmaIcon name={name} /> : null;
}
